// src/config/cdn.js
const BASE =
  import.meta.env?.VITE_ASSET_CDN ??
  import.meta.env?.VITE_CDN_BASE_URL ??
  '';

export function cdn(path = '') {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  if (BASE) return `${BASE.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;

  // Fallback for production: serve from /assets (put files in /public/assets)
  return `/assets/${path.replace(/^\/+/, '')}`;
}

export const CDN = {
  images: (p) => cdn(`images/${p}`),
  icons: (p) => cdn(`icons/${p}`),
  countries: (p) => cdn(`countries/${p}`),
  fonts: (p) => cdn(`fonts/${p}`)
};
